import { Controller } from "stimulus";

export default class extends Controller {
    static targets = ["selectedItems"]

    addItemToFieldValue() {
      const paidAmount = document.getElementById("bank_total_paid");
      const element = document.getElementById("selectedTransactions");
      const checkboxAllCommissions = document.getElementById("all_commissions");
      const allCommissions = document.getElementsByClassName("subCommissions");
      if (this.selectedItemsTarget.matches(".selected")) {
        this.selectedItemsTarget.classList.remove("selected");
        this.selectedItemsTarget.querySelector(".icon").classList.replace("fa-check-square", "fa-square");
        if (checkboxAllCommissions === this.selectedItemsTarget) {
          element.value = "";
          for (let i = 0; i < allCommissions.length; i += 1) {
            allCommissions[i].classList.remove("selected");
            allCommissions[i].querySelector(".icon").classList.replace("fa-check-square", "fa-square");
          }
          paidAmount.innerHTML = "Gesamtbetrag der gezahlten Summe: 0";
        } else {
          let oneCommission = document.getElementsByClassName(`${this.selectedItemsTarget.classList[2]}`);
          for (let i = 0; i < oneCommission.length; i += 1) {
            oneCommission[i].classList.remove("selected");
            oneCommission[i].querySelector(".icon").classList.replace("fa-check-square", "fa-square");
          }
          checkboxAllCommissions.classList.remove("selected");
          checkboxAllCommissions.querySelector(".icon").classList.replace("fa-check-square", "fa-square");
          element.value = element.value.replace(this.selectedItemsTarget.getAttribute("data-id"), "");
          this.recalculateTotalSum(allCommissions, paidAmount);
        }
      } else {
        this.selectedItemsTarget.classList.add("selected");
        this.selectedItemsTarget.querySelector(".icon").classList.replace("fa-square", "fa-check-square");
        if (checkboxAllCommissions === this.selectedItemsTarget) {
          element.value = ` ${this.selectedItemsTarget.getAttribute("data-id")}`;
          for (let i = 0; i < allCommissions.length; i += 1) {
            allCommissions[i].classList.add("selected");
            allCommissions[i].querySelector(".icon").classList.replace("fa-square", "fa-check-square");
          }
          this.recalculateTotalSum(allCommissions, paidAmount);
        } else {
          let commission = document.getElementsByClassName(`${this.selectedItemsTarget.classList[2]}`);
          for (let i = 0; i < commission.length; i += 1) {
            commission[i].classList.add("selected");
            commission[i].querySelector(".icon").classList.replace("fa-square", "fa-check-square");
          }
          element.value += ` ${this.selectedItemsTarget.getAttribute("data-id")}`;
          this.recalculateTotalSum(allCommissions, paidAmount);
        }
      }
    }

    recalculateTotalSum(allCommissions, paidAmount) {
      let totalSum = 0.0;
      for (let i = 0; i < allCommissions.length; i += 1) {
        if (allCommissions[i].classList.contains("selected")) {
          let amount = allCommissions[i].parentElement.parentElement.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling.childNodes[0].innerHTML;
          amount = parseFloat(amount.replace(/[€,]/g, "").replace(".", "")) / 100;
          totalSum += amount;
        }
      }
      document.getElementById("cash_payment_paid_amount").value = totalSum;
      totalSum = parseFloat((Math.round(totalSum * 100) / 100).toFixed(2)).toLocaleString("en-US", { style: "currency", currency: "EUR" });
      paidAmount.innerHTML = `Gesamtbetrag der gezahlten Summe: ${totalSum}`;
    }

    removeValue(element, dataId) {
      element.value = element.value.replace(dataId, "");
    }
}
